export default __webpack_public_path__ + "static/media/yeti.5e00ed62.mp4";